import deepmerge from 'deepmerge';
import { Action, Types } from './actions';

export interface AuthenticationState {
  isAuthenticated: boolean;
  isAuthLoaded: boolean;
  isLoaded: boolean;
  eID?: Api.eID;
  crsPersoon?: Api.CrsPersoon;
  user: Api.User;
}

export const initialState: AuthenticationState = {
  isAuthenticated: false,
  isAuthLoaded: false,
  isLoaded: false,
  user: {} as Api.User,
};

export const authenticationReducer = (
  state: AuthenticationState,
  action: Action,
): AuthenticationState => {
  switch (action.type) {
    case Types.SET_AUTHENTICATED: {
      const { user, crsPersoon, ...payload } = action.payload;

      return {
        ...state,
        isAuthLoaded: true,
        ...payload,
        user: {
          ...state.user,
          ...user,
        },
        crsPersoon,
      };
    }

    case Types.SET_USER: {
      return {
        ...state,
        isLoaded: true,
        user: action.payload,
      };
    }

    case Types.UPDATE_USER: {
      return {
        ...state,
        user: deepmerge(state.user, action.payload!, {
          arrayMerge: (destination: any[], source: any[]) => source,
        }),
      };
    }

    case Types.SET_EID: {
      return {
        ...state,
        eID: action.payload,
      };
    }

    default:
      return state;
  }
};
